import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";
import Avatar from "@material-ui/core/Avatar";
import PersonIcon from "@material-ui/icons/Person";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    padding: 0,
    minWidth: 400,
  },

  thumbnail: {
    width: 45,
    height: 45,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },

  main: {
    marginLeft: theme.spacing(3),
    padding: 0,
    flexGrow: 1,
  },

  title: {
    fontSize: "1.6rem",
    lineHeight: "1.7rem",
  },

  subtitle: {
    fontSize: "1.2rem",
  },
}));

const UserCard = ({ user }) => {
  const classes = useStyles();

  return (
    <Container className={classes.root} maxWidth={false}>
      <Avatar alt={user.username} className={classes.thumbnail}>
        <PersonIcon fontSize="large" />
      </Avatar>

      <div className={classes.main}>
        <div className={classes.title}>{user.username}</div>

        <div className={classes.subtitle}>{user.userId}</div>
      </div>
    </Container>
  );
};

export default UserCard;
